import { FC, memo } from 'react';

import { PointsListCheckboxGroupPointType } from 'application/components/PointItemContent/types';

import PointAddressItem from './PointAddressItem';

interface PointAddressesListProps {
  selectedPoints: PointsListCheckboxGroupPointType[];
  allDevicesOfPointsHasVideoSupport: boolean;
}

const PointAddressesList: FC<PointAddressesListProps> = ({ selectedPoints, allDevicesOfPointsHasVideoSupport }) => (
  <>
    {selectedPoints.map((point) => (
      <PointAddressItem
        key={point.id}
        point={point}
        allDevicesOfPointsHasVideoSupport={allDevicesOfPointsHasVideoSupport}
      />
    ))}
  </>
);

export default memo(PointAddressesList);
